import * as React from 'react';

function SvgComponent(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" fill="none" ref={svgRef} {...props}>
      <circle cx={40} cy={40} r={40} fill="#1CCCCB" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 51a4 4 0 004 4h28a4 4 0 004-4V29a4 4 0 00-4-4H26a4 4 0 00-4 4v22zm3-12.4v13.01a.4.4 0 00.4.4h29.204a.4.4 0 00.4-.4L55 38.6H25zm6.5-9.6h-6l2 6h6l-2-6zm6.5 6h6l-2-6h-6l2 6zm10.5 0h6l-2-6h-6l2 6z"
        fill="#fff"
      />
    </svg>
  );
}

const ContentDefaultIcon = React.forwardRef(SvgComponent);
export default ContentDefaultIcon;
